"use client";

import { useMountEffect } from "@opensea/ui-kit/hooks";
import { AccountActions } from "../accountStore";
import { PreviousAccountsActions } from "../previousAccountsStore";
export function useRehydrateAccount() {
  useMountEffect(_temp);
}
function _temp() {
  AccountActions.rehydrate();
  PreviousAccountsActions.rehydrate();
}